export default __webpack_public_path__ + "static/media/Ocean reef_primary.076da95c.jpg";